import React from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Paper,
  Stack,
  Divider,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SchoolIcon from '@mui/icons-material/School';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import FactoryIcon from '@mui/icons-material/Factory';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
// Styled components

  const HeroSection = styled(Box)(({ theme }) => ({
    position: 'relative',
    height: '50vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    backgroundImage: `url(${process.env.PUBLIC_URL}/img-2.jpg)`,
    padding: theme.spacing(4),
    marginBottom: theme.spacing(8),
    // Create the black overlay
  "::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Adjust opacity here (0.5 = 50% black)
    zIndex: 1,
  },

  // Ensure content appears above the overlay
  "& > *": {
    position: "relative",
    zIndex: 2,
  },
  }));
  
const StatsCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: 'center',
  background: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  color: 'white',
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  background: theme.palette.background.paper,
  margin: "auto",  // Add this line
}));



const Kovida = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const Kovida_Value = [
    {
      title: "Kovida Launch",
      image: "/img-1.jpg",
      content: `KOVIDA was launched in a National Seminar held in Delhi. The dignitaries present in the launch include Hon. Minister for Oil & Natural Gas Shri. Dharmendra Pradhan & BJP National Vice President Shri. Vinayaji Sahasrabuddhe, ABVP National Organizing Secretary Shri. Sunilji Ambekar who also shared their valuable thoughts & expectations from KOVIDA.`,
    },
    {
      title: "Kovida Entrepreneurship Development Program",
      image: "/img-2.jpg",
      content: `KOVIDA - NYCS has undertaken technical training for economically underprivileged youth, focusing on skill development and women empowerment. Training includes Entrepreneurship Development, Customer Service, Computer Hardware, and more.`,
    },
    {
      title: "Kovida CSR Programs",
      image: "/img-3.jpg",
      content: `NYCS - KOVIDA was awarded its first Skill Development Project under CSR of MNGL. The program trained 240 beneficiaries in Gas Plumbing, Welding, Fashion Designing, and other trades.`,
    },
    {
      title: "Kovida Campus Entrepreneurship Program",
      image: "/sport-2.jpg",
      content: `NYCS KOVIDA started a Campus Entrepreneurship and Incubation Programme (CEIP) to guide and mentor students to become entrepreneurs while in college.`,
    },
    {
      title: "Activities under Campus Entrepreneurship",
      image: "/sports-3.jpg",
      content: `Key activities include Awareness & Motivation about Entrepreneurship, Faculty Development Programme, Business Plan guidance, Mentoring, and Investor Meet facilitation.`,
    },
  ];

  return (
    <Box>
      {/* Hero Section */}
      <HeroSection>
        <Box sx={{ textAlign: 'center', maxWidth: 800 }}>
        <IconWrapper>
                        <SchoolIcon color="primary" sx={{ fontSize: 30 }} />
                    </IconWrapper>
          <Typography variant="h2" component="h1" gutterBottom>
            Kovida
          </Typography>
          <Typography variant="h5">
            Empowering Youth Through Skill Development
          </Typography>
        </Box>
      </HeroSection>

      <Container maxWidth="lg" sx={{marginTop:"20px"}}>
        {/* Overview Section */}
        <Card sx={{ mb: 6, mt: 8, position: 'relative', zIndex: 1 }}>
          <CardContent>
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={6}>
                <Typography variant="h4" gutterBottom color="primary">
                  Kovida Launch
                </Typography>
                <Typography variant="body1" paragraph>
                  KOVIDA was launched in a National Seminar held in Delhi. The dignitaries present in the launch include Hon. Minister for Oil & Natural Gas Shri. Dharmendra Pradhan & BJP National Vice President Shri. Vinayaji Sahasrabuddhe, ABVP National Organizing Secretary Shri. Sunilji Ambekar who also shared their valuable thoughts & expectations from KOVIDA.
                </Typography>
                <Stack spacing={2}>
                  <Box display="flex" alignItems="center">
                    <CheckCircleIcon color="primary" sx={{ mr: 2 }} />
                    <Typography>National level initiative</Typography>
                  </Box>
                  <Box display="flex" alignItems="center">
                    <CheckCircleIcon color="primary" sx={{ mr: 2 }} />
                    <Typography>Support from key dignitaries</Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  component="img"
                  src="/img-1.jpg"
                  alt="Kovida Launch"
                  sx={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: 2,
                  }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Entrepreneurship Development Section */}
        <Card sx={{ mb: 6, bgcolor: theme.palette.primary.main, color: 'white' }}>
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12} md={12}>
                <Typography variant="h4" gutterBottom>
                  Entrepreneurship Development Program
                </Typography>
                <Typography paragraph>
                  KOVIDA - NYCS has undertaken technical training for economically underprivileged youth, focusing on skill development and women empowerment.
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <StatsCard>
                      <Typography variant="h4">240+</Typography>
                      <Typography variant="subtitle1">Trained Beneficiaries</Typography>
                    </StatsCard>
                  </Grid>
                  <Grid item xs={6}>
                    <StatsCard>
                      <Typography variant="h4">Multiple</Typography>
                      <Typography variant="subtitle1">Training Programs</Typography>
                    </StatsCard>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h5" gutterBottom color="primary">
                      Key Program Areas
                    </Typography>
                    <Stack spacing={2}>
                      <Box display="flex" alignItems="center">
                        <CheckCircleIcon color="primary" sx={{ mr: 2 }} />
                        <Typography>Customer Service Training</Typography>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <CheckCircleIcon color="primary" sx={{ mr: 2 }} />
                        <Typography>Computer Hardware Skills</Typography>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <CheckCircleIcon color="primary" sx={{ mr: 2 }} />
                        <Typography>Fashion Designing Programs</Typography>
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Campus Programs Section */}
        <Card sx={{ mb: 6 }}>
          <CardContent>
            <Typography variant="h4" align="center" gutterBottom color="primary">
              Campus Entrepreneurship Program
            </Typography>
            <Typography align="center" paragraph sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}>
              NYCS KOVIDA's Campus Entrepreneurship and Incubation Programme (CEIP) guides and mentors students to become entrepreneurs while in college.
            </Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} md={4}>
                <Card variant="outlined">
                  <CardContent sx={{ textAlign: 'center' }}>
                    <IconWrapper sx={{margin:"auto"}}>
                      <SchoolIcon color="primary" sx={{ fontSize: 30 }} />
                    </IconWrapper>
                    <Typography variant="h6" gutterBottom>
                      Awareness
                    </Typography>
                    <Typography>
                      Entrepreneurship motivation and guidance
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card variant="outlined">
                  <CardContent sx={{ textAlign: 'center' }}>
                    <IconWrapper sx={{margin:"auto"}}>
                      <BusinessIcon color="primary" sx={{ fontSize: 30 }} />
                    </IconWrapper>
                    <Typography variant="h6" gutterBottom>
                      Development
                    </Typography>
                    <Typography>
                      Faculty and business plan development
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card variant="outlined">
                  <CardContent sx={{ textAlign: 'center' }}>
                    <IconWrapper sx={{margin:"auto"}}>
                      <PeopleIcon color="primary" sx={{ fontSize: 30 }} />
                    </IconWrapper>
                    <Typography variant="h6" gutterBottom>
                      Mentoring
                    </Typography>
                    <Typography>
                      Investor meet facilitation and guidance
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Box>
);
};

export default Kovida;